import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken} from '@/utils/auth' // get token from cookie

function getPageTitle(pageTitle) {
  
   if (pageTitle) {
        return pageTitle
    }
    return 'XCL'
}

NProgress.configure({showSpinner: false}) // NProgress Configuration

const whiteList = ['/login', '/register'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  
  // 原有的修改 Title 逻辑
  document.title = getPageTitle(to.meta.title)

  // === 新增：动态修改/生成 Meta Description 的逻辑 ===
  if (to.meta.description) {
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      // 如果页面里已经有描述标签，就替换掉
      metaDescription.setAttribute('content', to.meta.description);
    } else {
      // 如果没有，就自动创建一个塞进 <head> 里面
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      metaDescription.content = to.meta.description;
      document.head.appendChild(metaDescription);
    }
  }
  // ============================================

  next()
})

router.afterEach(() => {
    NProgress.done()
})
